import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { orderApi } from "../api/orderApi";
import AdminSidebar from "../components/AdminSidebar";
import Message from "../components/Message";

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);
  const [notice, setNotice] = useState(null);

  useEffect(() => {
    orderApi.getAdminOrders().then((data) => {
      setOrders(data.orders || data.items || []);
    }).catch((error) => setNotice({ type: "error", text: error.message }));
  }, []);

  return (
    <div className="admin-container">
      <AdminSidebar />
      <div className="admin-content">
        <div className="admin-header">
          <h1>Orders Management</h1>
        </div>
        <Message notice={notice} />

        {orders.length > 0 ? (
          <div className="orders-table-container">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Order Number</th>
                  <th>Customer Email</th>
                  <th>Total Amount</th>
                  <th>Status</th>
                  <th>Order Date</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {orders.map((order) => (
                  <tr key={order.id}>
                    <td>{order.order_number}</td>
                    <td>{order.user_email || order.user?.email}</td>
                    <td>${Number(order.total_price).toFixed(2)}</td>
                    <td><span className={`status-badge status-${order.status}`}>{String(order.status).toUpperCase()}</span></td>
                    <td>{new Date(order.created_at).toLocaleDateString()}</td>
                    <td>
                      <Link to={`/admin-order-detail/${order.id}`} className="btn btn-sm btn-primary">Edit</Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p>No orders found.</p>
        )}
      </div>
    </div>
  );
}
